import * as React from "react";
import { IExplorerProperties, IColumnMap } from "../../models";
import { ExplorerTabContent } from '../ExplorerTabContent';
import { WatchlistButton } from "../WatchlistButton";
import { safe, removeKeyWhenFalse, filterColumnsCSV, isNullOrUndefined, isPrint } from "../../utils";
import * as moment from "moment";
import { Disclaimer, MorningstarRating, AnalystRating } from "../../assets/";
import { FundExplorerFooter } from "./";

const styles = require('../FundPages/Fundpages.pcss');
const tabStyles = require('./FundExplorerTabs.pcss');

/*--- Interfaces ---*/

interface IProps {
    groupedRows: any[];
}

export class ExplorerTabPerformance extends React.Component<IProps & IExplorerProperties, {}>{
    constructor(props) {
        super(props);
    }

    getColumns(isPPL, csvDownload = false) {
        let { appParams, editWatchlist, watchlist, groupedRows, disclaimers } = this.props;
        let tooltipDefault = false;

        let dateHeadings = [];
        let endDate = null;
        if (groupedRows && groupedRows.length > 0) {
            for (let groupedRow of groupedRows) {
                for (let row of groupedRow.rows) {
                    endDate = safe(() => row.statisticsMapping['morning_star_yearly_perf']['M1']['end_date'], null);
                    if (endDate) {
                        break;
                    }
                }
                if (endDate) {
                    break;
                }
            }
        }
        if (!endDate) {
            endDate = moment().subtract(1, 'month').endOf('month');
        }
        if (endDate) {
            for (let i = 0; i < 5; i++) {
                dateHeadings.push({
                    start: moment(endDate).subtract(i + 1, 'year').add(1, "month").startOf("month").format('DD.MM.YY'),
                    end: moment(endDate).subtract(i, 'year').endOf("month").format('DD.MM.YY')
                });
            }
        }

        const hideFundName = !isPPL;
        const hideShareClass = isPPL;
        const hideCurrency = isPPL;
        const isPrivateInvestor = appParams.clienttype === "pri";
        const isCharity = appParams.clienttype === "cha";
        const isAdvisor = appParams.clienttype === "adv";
        const isDiscretionary = appParams.clienttype === "diw";

        let colSpanPerf = 0;
        let prerformanceHeading = "";
        let performanceColumns: IColumnMap[];
        if (isPrivateInvestor || isCharity || isAdvisor || isDiscretionary) {
            colSpanPerf = 6;
            prerformanceHeading = `Single year performance (5 years ending ${moment(endDate).format("MMMM")})(%)`;
            performanceColumns = [
                {
                    headerKey: "YTD (%)",
                    field: 'statisticsMapping.morning_star_trailing_perf.M0.value',
                    type: 'number',
                    isYearToDate: true,
                    precision: 2,
                    isCSV: true,
                    isPerformance: true,
                    headerClassName: tabStyles.yearlyPerf,
                    className: tabStyles.numberColumn
                },
                {
                    headerKey: 'From' + '\n' + 'To',
                    field: '',
                    tooltip: safe(() => disclaimers["TODO"][0]["disclaimers"][0], tooltipDefault),
                    className: tabStyles.blank,
                    type: 'custom',
                    explicitHide: false,
                    viewRestriction: 'table',
                    headerClassName: tabStyles.fromTodateRange
                },
                {
                    headerKey: dateHeadings[0].start + '\n' + dateHeadings[0].end,
                    field: 'statisticsMapping.morning_star_ytd_perf.M1.value',
                    type: 'number',
                    precision: 2,
                    isCSV: true,
                    isPerformance: true,
                    headerClassName: tabStyles.columnRight + ' ' + tabStyles.yearlyPerfBorderTop,
                    className: tabStyles.numberColumn
                },
                {
                    headerKey: dateHeadings[1].start + '\n' + dateHeadings[1].end,
                    field: 'statisticsMapping.morning_star_ytd_perf.M2.value',
                    type: 'number',
                    precision: 2,
                    isCSV: true,
                    isPerformance: true,
                    headerClassName: tabStyles.columnRight + ' ' + tabStyles.yearlyPerfBorderTop,
                    className: tabStyles.numberColumn
                },
                {
                    headerKey: dateHeadings[2].start + '\n' + dateHeadings[2].end,
                    field: 'statisticsMapping.morning_star_ytd_perf.M3.value',
                    type: 'number',
                    precision: 2,
                    isCSV: true,
                    isPerformance: true,
                    headerClassName: tabStyles.columnRight + ' ' + tabStyles.yearlyPerfBorderTop,
                    className: tabStyles.numberColumn
                },
                {
                    headerKey: dateHeadings[3].start + '\n' + dateHeadings[3].end,
                    field: 'statisticsMapping.morning_star_ytd_perf.M4.value',
                    type: 'number',
                    precision: 2,
                    isCSV: true,
                    isPerformance: true,
                    headerClassName: tabStyles.columnRight + ' ' + tabStyles.yearlyPerfBorderTop,
                    className: tabStyles.numberColumn
                },
                {
                    headerKey: dateHeadings[4].start + '\n' + dateHeadings[4].end,
                    field: 'statisticsMapping.morning_star_ytd_perf.M5.value',
                    type: 'number',
                    precision: 2,
                    isCSV: true,
                    isPerformance: true,
                    headerClassName: tabStyles.columnRight + ' ' + tabStyles.yearlyPerfBorderTop,
                    className: tabStyles.numberColumn
                },
                {
                    headerKey: "Since launch (%)",
                    field: 'statisticsMapping.morning_star_trailing_perf.M255.value',
                    type: 'number',
                    precision: 2,
                    isCSV: true,
                    isPerformance: true,
                    headerClassName: tabStyles.columnRight + ' ' + tabStyles.sinceLaunch,
                    className: tabStyles.numberColumn
                },
            ];
        }
        else {
            colSpanPerf = 7;
            prerformanceHeading = "Annualised performance (% p.a.)";
            performanceColumns = [
                {
                    headerKey: "YTD (%)",
                    field: 'statisticsMapping.morning_star_trailing_perf.M0.value',
                    type: 'number',
                    precision: 2,
                    isCSV: true,
                    isPerformance: true,
                    headerClassName: tabStyles.yearlyPerf,
                    className: tabStyles.numberColumn
                },
                {
                    headerKey: "1 YR",
                    field: 'statisticsMapping.morning_star_trailing_perf.M12.value',
                    type: 'number',
                    precision: 2,
                    isCSV: true,
                    isPerformance: true,
                    headerClassName: tabStyles.yearlyPerf + ' ' + tabStyles.yearlyPerfBorderTop,
                    className: tabStyles.numberColumn
                },
                {
                    headerKey: "2 YR",
                    field: 'statisticsMapping.morning_star_trailing_perf.M24.value',
                    type: 'number',
                    precision: 2,
                    isCSV: true,
                    isPerformance: true,
                    headerClassName: tabStyles.yearlyPerf + ' ' + tabStyles.yearlyPerfBorderTop,
                    className: tabStyles.numberColumn
                },
                {
                    headerKey: "3 YR",
                    field: 'statisticsMapping.morning_star_trailing_perf.M36.value',
                    type: 'number',
                    precision: 2,
                    isCSV: true,
                    isPerformance: true,
                    headerClassName: tabStyles.yearlyPerf + ' ' + tabStyles.yearlyPerfBorderTop,
                    className: tabStyles.numberColumn
                },
                {
                    headerKey: "4 YR",
                    field: 'statisticsMapping.morning_star_trailing_perf.M48.value',
                    type: 'number',
                    precision: 2,
                    isCSV: true,
                    isPerformance: true,
                    headerClassName: tabStyles.yearlyPerf + ' ' + tabStyles.yearlyPerfBorderTop,
                    className: tabStyles.numberColumn
                },
                {
                    headerKey: "5 YR",
                    field: 'statisticsMapping.morning_star_trailing_perf.M60.value',
                    type: 'number',
                    precision: 2,
                    isCSV: true,
                    isPerformance: true,
                    headerClassName: tabStyles.yearlyPerf + ' ' + tabStyles.yearlyPerfBorderTop,
                    className: tabStyles.numberColumn
                },
                {
                    headerKey: "Since launch (%)",
                    field: 'statisticsMapping.morning_star_trailing_perf.M255.value',
                    type: 'number',
                    precision: 2,
                    isCSV: true,
                    isPerformance: true,
                    headerClassName: tabStyles.columnRight + ' ' + tabStyles.sinceLaunch,
                    className: tabStyles.numberColumn
                },
            ];
        }

        let columns: IColumnMap[] = [
            {
                headerKey: 'Fund Name',
                field: 'display',
                entity: "fund",
                type: 'string',
                isCSV: true,
                viewRestriction: 'table',
                explicitHide: hideFundName,
                headerClassName: tabStyles.fundNameColumn,
                headerRowSpan: 1,
                className: tabStyles.fundNameRow
            },
            {
                headerKey: 'Share Class',
                field: 'properties.shareclass_display',
                type: 'string',
                isCSV: true,
                viewRestriction: 'table',
                tooltip: safe(() => disclaimers["TODO"][0]["disclaimers"][0], tooltipDefault),
                explicitHide: hideShareClass,
                headerRowSpan: 1,
                headerClassName: tabStyles.columnLeft,
                className: tabStyles.firstColumn
            },
            {
                headerKey: 'Currency',
                field: 'statisticsMapping.morning_star_internal_details.performance_currency',
                tooltip: safe(() => disclaimers["TODO"][0]["disclaimers"][0], tooltipDefault),
                explicitHide: hideCurrency,
                headerRowSpan: 1,
                isCSV: true,
                type: 'string'
            },
            {
                headerKey: 'As at date',
                field: 'properties.xd_date',
                type: 'date',
                isCSV: true,
                headerRowSpan: 1,
                headerClassName: tabStyles.dateColumn
            },
            {
                headerKey: prerformanceHeading,
                type: 'string',
                field: '',
                viewRestriction: "card",
                headerColSpan: colSpanPerf,
                isParentHeader: true,
                explicitHide: true,
                headerClassName: tabStyles.minorRow
            },
            ...performanceColumns,
            {
                headerKey: 'Mstar Rating',
                type: 'component',
                isCSV: true,
                component: <MorningstarRating />,
                getPropsFn: (row, groupedRow) => {
                    return {
                        stars: row.properties.morningstar_rating
                    };
                },
                headerRowSpan: 1,
                tooltip: safe(() => disclaimers["tooltip_morningstar_rating™"][0]["disclaimers"][0], tooltipDefault),
            },

            {
                headerKey: 'Mstar Analyst Rating',
                type: 'component',
                isCSV: true,
                component: <AnalystRating />,
                getPropsFn: (row, groupedRow) => {
                    return {
                        stars: row.properties.analyst_rating
                    };
                },
                headerRowSpan: 1,
                explicitHide: isCharity || isPrivateInvestor,
                tooltip: safe(() => disclaimers["tooltip_morningstar_analyst_rating"][0]["disclaimers"][0], tooltipDefault),
            },
            {
                headerKey: 'ISIN',
                field: 'properties.isin',
                type: 'string',
                isCSV: true,
                tooltip: safe(() => disclaimers["tooltip_isin"][0]["disclaimers"][0], tooltipDefault),
                headerRowSpan: 1,
                headerClassName: tabStyles.isinColumn
            },
            {
                headerKey: 'Watchlist',
                type: 'component',
                viewRestriction: 'table',
                component: <WatchlistButton appParams={appParams} watchlist={watchlist} editWatchlist={editWatchlist}></WatchlistButton>,
                getPropsFn: (row, groupedRow) => {
                    return {
                        fundName: groupedRow.display,
                        fundIdentifier: groupedRow.fund.clientCode,
                        isin: row.clientCode
                    };
                },
                displayLimitation: "web",
                headerRowSpan: 1,
                headerClassName: tabStyles.watchListColumn
            }
        ];

        if (csvDownload) {
            return filterColumnsCSV(columns, isPPL);
        }

        return removeKeyWhenFalse(columns, "tooltip");
    }

    getMStarDate(funds) {
        let date: string;
        for (let fund of funds) {
            let checkdate;
            for (let share of fund.shareClasses) {
                checkdate = safe(() => share.statisticsMapping.morning_star_rating.date, null);
                if (!isNullOrUndefined(checkdate)) {
                    date = checkdate;
                    break;
                }
            }
            if (!isNullOrUndefined(checkdate)) {
                break;
            }
        }
        return date;
    }

    render() {
        let { funds, appParams, disclaimers } = this.props;
        let { clienttype, productrange } = appParams;
        const showMStarOverall = clienttype === "pri" || clienttype === "cha";
        const isPPL = productrange === "PPL";

        return (
            <div className={styles.tabPerformance}>
                <ExplorerTabContent {...this.props} isPPL={isPPL} columns={this.getColumns(isPPL)} />
                <FundExplorerFooter {...this.props} />
                {!isPrint(appParams) &&
                    <div className="">
                        <Disclaimer appParams={appParams} disclaimer={disclaimers["performance_disclaimer"]} hideStatic={true} />
                        <Disclaimer appParams={appParams} date={this.getMStarDate(funds.values)} disclaimer={disclaimers[(showMStarOverall ? "ratings_ratingsmorningstaroverall" : "ratings_ratingsmorningstaroverallandanalyst")]} />
                    </div>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/components/FundExplorerTabs/FundExplorerPerformanceTab.tsx